<template><div><dt-notice kind="error" :show-close="false" class="d-wmx100p d-my-200 dialtone-doc-notice">
<code v-pre>d-stack</code> and <code v-pre>d-flow</code> utilities are deprecated. Please use the <a href="/components/stack" class="d-docsite--link d-link" target="_blank" rel="noopener noreferrer">Stack</a> component instead.
</dt-notice>
<h2 id="adding-space-vertically" tabindex="-1" class="d-docsite--header-2">Adding Space Vertically <a class="header-anchor d-link d-docsite--link d-link" href="#adding-space-vertically" aria-hidden="true">#</a></h2>
<code-example source-code='&lt;div class=&quot;d-bgc-bold d-stack16 d-bar-400 lg:d-w-150 d-w-200&quot;&gt;
  &lt;div class=&quot;d-p-200 d-bar-400 d-bgc-moderate d-ta-center&quot;&gt;1&lt;/div&gt;
  &lt;div class=&quot;d-p-200 d-bar-400 d-bgc-moderate d-ta-center&quot;&gt;2&lt;/div&gt;
  &lt;div class=&quot;d-p-200 d-bar-400 d-bgc-moderate d-ta-center&quot;&gt;3&lt;/div&gt;
&lt;/div&gt;'>
<div class="d-bgc-bold d-stack16 d-bar-400 lg:d-w-150 d-w-200">
  <div class="d-p-200 d-bar-400 d-bgc-moderate d-ta-center">1</div>
  <div class="d-p-200 d-bar-400 d-bgc-moderate d-ta-center">2</div>
  <div class="d-p-200 d-bar-400 d-bgc-moderate d-ta-center">3</div>
</div>
</code-example>
<h2 id="adding-space-horizontally" tabindex="-1" class="d-docsite--header-2">Adding Space Horizontally <a class="header-anchor d-link d-docsite--link d-link" href="#adding-space-horizontally" aria-hidden="true">#</a></h2>
<code-example source-code='&lt;div class=&quot;d-fl-center d-bgc-bold d-flow24 d-bar-400 d-ta-center&quot;&gt;
  &lt;div class=&quot;lg:d-w-150 d-w-200 d-p-200 d-bar-400 d-bgc-moderate&quot;&gt;1&lt;/div&gt;
  &lt;div class=&quot;lg:d-w-150 d-w-200 d-p-200 d-bar-400 d-bgc-moderate&quot;&gt;2&lt;/div&gt;
  &lt;div class=&quot;lg:d-w-150 d-w-200 d-p-200 d-bar-400 d-bgc-moderate&quot;&gt;3&lt;/div&gt;
&lt;/div&gt;'>
<div class="d-fl-center d-bgc-bold d-flow24 d-bar-400 d-ta-center">
  <div class="lg:d-w-150 d-w-200 d-p-200 d-bar-400 d-bgc-moderate">1</div>
  <div class="lg:d-w-150 d-w-200 d-p-200 d-bar-400 d-bgc-moderate">2</div>
  <div class="lg:d-w-150 d-w-200 d-p-200 d-bar-400 d-bgc-moderate">3</div>
</div>
</code-example>
<h2 id="classes" tabindex="-1" class="d-docsite--header-2">Classes <a class="header-anchor d-link d-docsite--link d-link" href="#classes" aria-hidden="true">#</a></h2>
<p class="d-docsite--paragraph">The Stack and Flow layouts work by using the adjacent sibling combinator (<code v-pre>+</code>) to apply a top or left margin to sibling elements. This means it will only work when there are more than two sibling items. To allow for differing nesting spacing values, these margins are scoped to apply <strong>only</strong> to direct children of the parent (e.g. <code v-pre>.d-stack[#] &gt; * + *</code>).</p>
<clamped-table-wrapper>
  <div>
    <table class="d-table dialtone-doc-table">
      <thead class="d-bgc-primary d-ps-sticky d-zi-base1 d-ibs-0">
        <tr>
          <th scope="col" class="d-p-0 d-bbw0 d-w25p"><div class="d-p-200 d-bb d-bbw1">Value</div></th>
          <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Vertical Class</div></th>
          <th scope="col" class="d-p-0 d-bbw0"><div class="d-p-200 d-bb d-bbw1">Horizontal Class</div></th>
        </tr>
      </thead>
      <tbody>
        <tr v-for="{ value: val } in values">
          <th scope="row">{{ val }}px</th>
          <td class="d-code--sm d-docsite-code">.d-stack{{ val }}</td>
          <td class="d-code--sm d-docsite-code">.d-flow{{ val }}</td>
        </tr>
      </tbody>
    </table>
  </div>
</clamped-table-wrapper>
</div></template>


<script setup>
  import { values } from '@data/auto-spacing.json';
  import ClampedTableWrapper from '@baseComponents/ClampedTableWrapper.vue';
</script>